import OsParser from './parser';
const ua = window.navigator.userAgent;
const os = new OsParser(ua);
export const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; // android终端
export const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
export const getOSName = os.getOSName.bind(os);
export const getOSVersion = os.getOSVersion.bind(os);
